import React, { useState, useEffect, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { getActivityById, updateActivity } from "../api";
import DatePicker from "react-datepicker";
import { es } from "date-fns/locale";
import "react-datepicker/dist/react-datepicker.css";

const EditActForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();

  // ✅ LEER 'id' (coincide con :id en la ruta)
  const { id } = useParams();

  // ✅ company desde localStorage
  const company = JSON.parse(localStorage.getItem("company"));
  const user = JSON.parse(localStorage.getItem("user"));

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // estado del form
  const [idActivity, setIdActivity] = useState("");
  const [codMaq, setCodMaq] = useState("");
  const [idProd, setIdProd] = useState("");
  const [idShift, setIdShift] = useState("");
  const [idOperator, setIdOperator] = useState("");
  const [observations, setObservations] = useState("");
  const [dateAct, setDateAct] = useState(null);
  const [timeBegin, setTimeBegin] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);

  // helpers de tiempo
  const hhmmssToDate = (t) => {
    if (!t) return null;
    const [h, m] = String(t).split(":");
    const d = new Date();
    d.setHours(Number(h)||0, Number(m)||0, 0, 0);
    return d;
  };
  const formatDate = (d) => d ? `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}` : null;
  const formatTime = (d) => d ? `${String(d.getHours()).padStart(2,"0")}:${String(d.getMinutes()).padStart(2,"0")}:00` : null;

  useEffect(() => {
    const load = async () => {
      try {
        if (!company?.id_c) { alert("Falta company"); return navigate(-1); }
        if (!id) { alert("ID de actividad no encontrado"); return navigate(-1); }

        console.log("Edit activity id:", id); // ahora debe mostrar 7 (por tu ejemplo)
        const actId = Number(id); // el backend espera número

        const { activity } = await getActivityById(company.id_c, actId);

        setIdActivity(activity.id_activity || "");
        setCodMaq(activity.cod_maq || "");
        setIdProd(activity.id_prod || "");
        setIdShift(activity.id_shift || "");
        setIdOperator(activity.id_operator || "");
        setObservations(activity.observations || "");
        setDateAct(activity.date_act ? new Date(activity.date_act) : null);
        setTimeBegin(hhmmssToDate(activity.time_begin));
        setTimeEnd(hhmmssToDate(activity.time_end));
      } catch (e) {
        console.error("❌ Error fetching activity:", e);
        alert(t("Error al cargar la actividad"));
        navigate(-1);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [company?.id_c, id, navigate, t]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const actId = Number(id);
      const payload = {
        id_activity: idActivity,
        cod_maq: codMaq,
        id_prod: idProd || null,
        id_shift: idShift || null,
        id_operator: idOperator || null,
        observations: observations || null,
        date_act: formatDate(dateAct),
        time_begin: formatTime(timeBegin),
        time_end: formatTime(timeEnd),
        // opcional: id_user: user?.id_u
      };
      await updateActivity(company.id_c, actId, payload);
      alert(t("Actividad actualizada"));
      navigate(-1);
    } catch (e) {
      console.error("❌ Error updating activity:", e);
      alert(t("Ocurrió un error al actualizar la actividad."));
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p className="box1">{t("Cargando...")}</p>;

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSave}>
          <table className="form1">
            <tbody>
              <tr>
                <td><label>{t("actType2") || "Tipo de Actividad"}</label></td>
                <td><input className="input1" value={idActivity} onChange={(e)=>setIdActivity(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>{t("batchList2") || "Código de Máquina"}</label></td>
                <td><input className="input1" value={codMaq} onChange={(e)=>setCodMaq(e.target.value)} required/></td>
              </tr>
              <tr>
                <td><label>{t("batchList3") || "Producto"}</label></td>
                <td><input className="input1" value={idProd} onChange={(e)=>setIdProd(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>{t("shifts1") || "Turno"}</label></td>
                <td><input className="input1" value={idShift} onChange={(e)=>setIdShift(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>{t("operator1") || "Operador"}</label></td>
                <td><input className="input1" value={idOperator} onChange={(e)=>setIdOperator(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>{t("observations") || "Observaciones"}</label></td>
                <td><textarea className="input1" rows="3" value={observations} onChange={(e)=>setObservations(e.target.value)} /></td>
              </tr>
              <tr>
                <td><label>{t("batchList7") || "Fecha"}</label></td>
                <td>
                  <DatePicker
                    selected={dateAct}
                    onChange={setDateAct}
                    dateFormat="yyyy-MM-dd"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>
              <tr>
                <td><label>{t("batchList8") || "Hora Inicio"}</label></td>
                <td>
                  <DatePicker
                    selected={timeBegin}
                    onChange={setTimeBegin}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>
              <tr>
                <td><label>{t("batchList10") || "Hora Fin"}</label></td>
                <td>
                  <DatePicker
                    selected={timeEnd}
                    onChange={setTimeEnd}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    className="input1"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <button type="submit" className="button7" disabled={saving}>
            {saving ? t("Guardando...") : t("Guardar")}
          </button>
          <button type="button" className="button7" onClick={()=>navigate(-1)}>
            {t("Cancelar")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditActForm;
